import { SALES_OPTION_ICON } from "@/enums/business.enum";
import { Location } from "@/modules/location";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import { SaleOptionInterface } from "@/interface/business/saleOption.interface";

class SaleOption implements SaleOptionInterface {
  id?: string;
  locations: Array<any> = [];
  name: string = "";
  type: string = "";
  icon: string = "";
  charges: Array<any> = [];
  locationsNames?: Array<string>;

  constructor(data) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.type = data.type;
      this.locations = data.locations?.map((location) => new Location(location)) || [];
      this.setIcon();
      this.prepareLocations(data);
    }
  }

  private setIcon() {
    this.icon = SALES_OPTION_ICON[this.type];
  }

  /**
   * prepare locations and phone number to be sent to back end
   * @param form
   * @return SaleOption
   */
  public prepareFormBody(isCustomForm) {
    if (!isCustomForm) {
      this.locations = this.locations.map((location) => {
        return {
          id: location.id,
          charges: this.charges,
        };
      });
    }
    return this;
  }

  /**
   * map the locations name to the location id
   * @param data
   * @private
   */
  private prepareLocations(data) {
    const locationsList = Storage.get(StorageConstants.LOCATIONS).map((location) => new Location(location));
    this.locations = data?.locations?.map((originalLocation) => {
      let mutualLocation = locationsList.find((location) => location.id === originalLocation.id);
      return { ...mutualLocation, ...originalLocation };
    });
  }
}

export default SaleOption;
